export const createViewSlice = (set) => ({
    view: {
        userAddModal: false,
        userUploadExcel: false,
        companyModal: false,
        seoModal: false,
        newTicketModal: false,
        seoEditModal: false,
        seoHistoryModule: false,
        companyEditModal: false,
        userEditModal: false,
        userSalesModal: false,
        businessShowModal: false,
        businessEditModal: false,
        businessNewEditModal: false,
        businessAddModal: false,
        postEditModal: false,
        agentWagePaidModal: false,
        userBoughtModal: false,
        companyDefaultAgent: false,
        editCompanyDefaultAgent: false,
        editInsuranceDefaultAgent: false,
        error: '',
        crmCallModal: false,
        success: '',
        successTime: null,
        newUserModal: false,
        errorTime: null,
        userWageSettingModal: false,
        userAddAgentWageModal: false,
        userEditAgentWageModal: false,
        detailTicketModal: false,
        crmReportModal: false,
        promoterUserModal:false,
        crmTicketInfoReportModal: false,
        crmCallHistoryModal: false,
        crmCallItemsModal: false,
        crmCallReasonModal: false,
        insuranceDetailsModal: false,
        endorsementDetailsModal: false,
        renewalCallModal: false,
        insuranceDetailsPrevRequestId: null,
        loading: false,
        contactUsModal: false,
        itemModal: null,
        userEndorsementReportModal: false,
        changeMobileModal: false,
    },
    NotifSuccess: (payload) => set(state => ({ view: { ...state.view, success: payload, successTime: Date.now() } })),
    NotifError: (payload) => set(state => ({ view: { ...state.view, error: payload, errorTime: Date.now() } })),
    ToggleUserAddModal: () => set(state => ({ view: { ...state.view, userAddModal: !state.view.userAddModal } })),
    ToggleUserUploadExcel: () => set(state => ({ view: { ...state.view, userUploadExcel: !state.view.userUploadExcel } })),
    ToggleEditUserModal: () => set(state => ({ view: { ...state.view, userEditModal: !state.view.userEditModal } })),
    ToggleUserSalesModal: () => set(state => ({ view: { ...state.view, userSalesModal: !state.view.userSalesModal } })),
    ToggleCompanyModal: () => set(state => ({ view: { ...state.view, companyModal: !state.view.companyModal } })),
    ToggleCompanyEditModal: () => set(state => ({ view: { ...state.view, companyEditModal: !state.view.companyEditModal } })),
    ToggleSeoModal: () => set(state => ({ view: { ...state.view, seoModal: !state.view.seoModal } })),
    ToggleNewTicketModal: () => set(state => ({ view: { ...state.view, newTicketModal: !state.view.newTicketModal } })),
    ToggleCrmCallHistoryModal: () => set(state => ({ view: { ...state.view, crmCallHistoryModal: !state.view.crmCallHistoryModal } })),
    ToggleCrmCallItemsModal: () => set(state => ({ view: { ...state.view, crmCallItemsModal: !state.view.crmCallItemsModal } })),
    ToggleCrmCallReasonModal: () => set(state => ({ view: { ...state.view, crmCallReasonModal: !state.view.crmCallReasonModal } })),
    ToggleSeoEditModal: () => set(state => ({ view: { ...state.view, seoEditModal: !state.view.seoEditModal } })),
    ToggleSeoHistoryModal: () => set(state => ({ view: { ...state.view, seoHistoryModule: !state.view.seoHistoryModule } })),
    ToggleBusinessShowModal: () => set(state => ({ view: { ...state.view, businessShowModal: !state.view.businessShowModal } })),
    ToggleBusinessEditModal: () => set(state => ({ view: { ...state.view, businessEditModal: !state.view.businessEditModal } })),
    ToggleBusinessNewEditModal: () => set(state => ({ view: { ...state.view, businessNewEditModal: !state.view.businessNewEditModal } })),
    TogglePostEditModal: () => set(state => ({ view: { ...state.view, postEditModal: !state.view.postEditModal } })),
    ToggleAddAgentWagePaidModal: () => set(state => ({ view: { ...state.view, agentWagePaidModal: !state.view.agentWagePaidModal } })),
    ToggleUserBoughtModal: () => set(state => ({ view: { ...state.view, userBoughtModal: !state.view.userBoughtModal } })),
    ToggleCompanyDefaultAgentModal: () => set(state => ({ view: { ...state.view, companyDefaultAgent: !state.view.companyDefaultAgent } })),
    ToggleEditCompanyDefaultAgentModal: () => set(state => ({ view: { ...state.view, editCompanyDefaultAgent: !state.view.editCompanyDefaultAgent } })),
    ToggleEditInsuranceDefaultAgentModal: () => set(state => ({ view: { ...state.view, editInsuranceDefaultAgent: !state.view.editInsuranceDefaultAgent } })),
    ToggleUserWageSettingModal: () => set(state => ({ view: { ...state.view, userWageSettingModal: !state.view.userWageSettingModal } })),
    ToggleUserAddAgentWage: () => set(state => ({ view: { ...state.view, userAddAgentWageModal: !state.view.userAddAgentWageModal } })),
    ToggleUserEditAgentWage: () => set(state => ({ view: { ...state.view, userEditAgentWageModal: !state.view.userEditAgentWageModal } })),
    ToggleInsuranceDetailsModal: () => set(state => ({ view: { ...state.view, insuranceDetailsModal: !state.view.insuranceDetailsModal } })),
    ToggleEndorsementDetailsModal: () => set(state => ({ view: { ...state.view, endorsementDetailsModal: !state.view.endorsementDetailsModal } })),
    ToggleRenewalCallModal: () => set(state => ({ view: { ...state.view, renewalCallModal: !state.view.renewalCallModal } })),
    ToggleContactUsModal: (payload) => set(state => ({ view: { ...state.view, contactUsModal: !state.view.contactUsModal, itemModal: payload } })),
    ToggleDetailsTicketFormModal: (payload) => set(state => ({ view: { ...state.view, detailTicketModal: payload } })),
    ToggleCrmReportModal: (payload) => set(state => ({ view: { ...state.view, crmReportModal: payload } })),
    TogglePromoterUserModal: (payload) => set(state => ({ view: { ...state.view, promoterUserModal: payload } })),
    ToggleCrmTicketInfoReportModal: (payload) => set(state => ({ view: { ...state.view, crmTicketInfoReportModal: payload } })),
    SetInsuranceDetailsPrevRequestId: (payload) => set(state => ({ view: { ...state.view, insuranceDetailsPrevRequestId: payload } })),
    GeneralLoadingStop: () => set(state => ({ view: { ...state.view, loading: false } })),
    ToggleCrmNewUserModal: () => set(state => ({ view: { ...state.view, newUserModal: !state.view.newUserModal } })),
    GeneralLoadingStart: () => set(state => ({ view: { ...state.view, loading: true } })),
    ToggleCrmCallModal: (payload) => set(state => ({ view: { ...state.view, crmCallModal: payload } })),
    ToggleUserEndorsementReportModal: () => set(state => ({ view: { ...state.view, userEndorsementReportModal: !state.view.userEndorsementReportModal } })),
    ToggleChangeMobileModal: (payload) => set(state => ({ view: { ...state.view, changeMobileModal: typeof payload === 'boolean' ? payload : !state.view.changeMobileModal } }))
});
